
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
          <v-row class="d-flex justify-center mt-3">
            <v-col cols="4">
              <v-text-field
                label="Pergunta"
                v-model="form.filters.pergunta"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <sigfoco-select-ativo
              :cols="2"
              v-model="form.filters.situacao"
              labelType="Situação"
            ></sigfoco-select-ativo>
          </v-row>
          <v-row class="d-flex justify-center mt-3">
            <sigfoco-date-picker
              :cols="2"
              label="Data Início"
              v-model="form.filters.dataInicio"
              removeIcon
              outlined
              dense
            ></sigfoco-date-picker>
            <sigfoco-date-picker
              :cols="2"
              v-model="form.filters.dataFim"
              label="Data Final"
              removeIcon
              outlined
              dense
            ></sigfoco-date-picker>
            </v-row>
          <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                text="Buscar"
                icon="mdi-magnify"
                @click="buscarRelatorios"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Limpar"
                icon="mdi-eraser"
                @click="resetForm"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5 printable"
          :headers="headersAnalitico"
          :items="form.lists.listRelatorios"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
          sort-by="dataHoraDaAcao"
          :sort-desc="true"
          show-expand
          :expanded.sync="expanded"
        >
          <template v-slot:[`item.pergunta`]="{ item }">
            <div class="pergunta-container">
              {{ item.pergunta }}
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td class="resposta" :colspan="headers.length">
              {{ item.resposta }}
            </td>
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            <sigfoco-label-ativo-inativo :ativo="item.situacao"></sigfoco-label-ativo-inativo>
          </template>
          <template v-slot:[`item.dataHoraDaAcao`]="{ item }">
            {{ $formatarDataHora(item.dataHoraDaAcao) }}
          </template>
          <template v-slot:[`item.acao`]="{ item }">
            {{ item.acao }}
          </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorios.length"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
  <script>
  import pageLoadingMixin from "mixins/page-loading.mixin";
  import RelatorioDeLogFAQ from "services/relatorios-log/manter-faq-log.service"
  
  export default {
    name: "RelatorioLogFaq",
    mixins: [pageLoadingMixin, RelatorioDeLogFAQ],
  
    data: () => ({
      onReport: false,
      form: {
        filters: {
          pergunta: null,
          situacao: null,
          dataInicio: null,
          dataFim: null,
        },
        lists: {
          listRelatorios: [],
        },
      },
      opcoesStatus: [
        { value: true, descricao: "Ativo" },
        { value: false, descricao: "Inativo" },
      ],
      headersAnalitico: [
        { text: "Pergunta", align: "center", value: "pergunta" },
        { text: "Resposta", align: "center", value: "data-table-expand" },
        { text: "Situação", align: "center", value: "situacao" },
        { text: "Data/Hora da ação", align: "center", value: "dataHoraDaAcao" },
        { text: "Ação", align: "center", value: "acao" },
      ],
    }),
  
    methods: {
      async buscarRelatorios() {
        const isValid = this.validarDatas();
        if (!isValid) return;
        if (!this.verificarFiltrosPreenchidos()) return;

        const preparedRequest = this.prepararRequisicao();
        this.showPageLoading();
        try {
          const { data } = await this.$obterRelatorioLogFAQ(this.$montarParamsFilters(preparedRequest));
          this.processarRespostaRelatorio(data);
        } finally {
          this.hidePageLoading();
        }
      },
      validarDatas() {
        const { dataInicio, dataFim } = this.form.filters;
        if (dataInicio && dataFim) {
          if (new Date(dataFim) < new Date(dataInicio)) {
            this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
            return false;
          }
          if (new Date(dataInicio) > new Date(dataFim)) {
            this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
            return false;
          }
        }
        return true;
      },
    
      verificarFiltrosPreenchidos() {
        const { pergunta, situacao, dataInicio, dataFim } = this.form.filters;
        if (!pergunta && situacao == null && !dataInicio && !dataFim) {
            this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
            return false;
        }
        return true;
      },
    
      async baixarCSVRelatorio() {
        const preparedRequest = this.prepararRequisicao();
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogCSVFAQ(this.$montarParamsFilters(preparedRequest));
        this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeLogDeFAQCSV`);
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
          this.hidePageLoading();
        }
      },
    
      async baixarRelatorioPdf() {
        const preparedRequest = this.prepararRequisicao();
        this.showPageLoading();
        try {
          const { data } = await this.$obterRelatorioLogPDFFAQ(this.$montarParamsFilters(preparedRequest));
          const url = URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "SIGFOCO.RelatórioDeLogDeFAQ.pdf");
          document.body.appendChild(link);
          link.click();
          this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
          this.hidePageLoading();
        }
      },
      prepararRequisicao() {
        return {
          pergunta: this.form.filters.pergunta,
          situacao: this.form.filters.situacao,
          dataInicio: this.form.filters.dataInicio,
          dataFim: this.form.filters.dataFim,
        };
      },
    
      processarRespostaRelatorio(data) {
          this.form.lists.listRelatorios = data.relatorio?.lista;
      },

      resetForm() {
        this.form.filters.dataInicio = null;
        this.form.filters.dataFim = null;
  
        this.$nextTick(() => {
          this.$set(this.form.filters, 'dataInicio', null);
          this.$set(this.form.filters, 'dataFim', null);
        });
        this.form.filters.pergunta = null;
        this.form.filters.situacao = null;
        this.form.lists.listRelatorios = [];
        this.expanded = [];
      }
    },
};

</script>
<style scoped>
.resposta {
  white-space: pre-wrap;
  padding: 1em !important;
  text-align: left;
  font-weight: bold;
}
.pergunta-container {
  word-wrap: break-word;
  white-space: normal;
}
</style>